import {
  CarouselButtons,
  CarouselBase,
  CarouselCard,
  Skeleton
} from 'ui';
import { getThumbnail } from 'utils/thumbnails';
import { useSlidesPerView, useObserver } from 'hooks'
import useResponsive from 'utils/hooks/useResponsive';
import { Div, Text } from '..';
import { useTheme } from 'styled-components';

const Carousel = ({
  title,
  uuid,
  hideUntilData,
  fetchFn = () => ({})
}) => {

  const { slidesPerView } = useSlidesPerView();
  const { Observer, inView } = useObserver()
  const { isTab, isMobile } = useResponsive()
  const theme = useTheme()

  const {
    isLoading,
    isError,
    data = [],
  } = fetchFn(uuid, inView)

  if (isError) return (
    <div>ERROR!</div>
  )

  if (!inView) return <Observer />

  if (hideUntilData && !data.length) return null

  if (isLoading || !data.length) return (
    <Div margin={isTab ? 0 : `0 ${theme.old.sizes.sidesMargin.large}`}>
      <Div
        margin={isTab
          ? `40px ${theme.old.sizes.sidesMargin.small} 15px`
          : `40px 0 15px`
        }
      >
        <Text
          size={isMobile ? 'base' : 'xl'}
          color='headline'
          weight='semibold'
        >
          {title}
        </Text>
      </Div>

      <CarouselBase key='skeletons' slidesPerView={slidesPerView}>
        {Array(slidesPerView + 1).fill(
          <Skeleton key={Date.now()} />
        )}
      </CarouselBase>
    </Div>
  )


  return (
    <Div margin={isTab ? 0 : `0 ${theme.old.sizes.sidesMargin.large}`}>
      <Div
        margin={isTab
          ? `40px ${theme.old.sizes.sidesMargin.small} 15px`
          : `40px 0 15px`
        }
      >
        <Text
          size={isMobile ? 'base' : 'xl'}
          color='headline'
          weight='semibold'
        >
          {title}
        </Text>
      </Div>

      <CarouselBase
        key='content'
        title={title}
        slidesPerView={slidesPerView}
        offsetRight={isTab ? 16 : 0}
        rewind
        renderNavigationBtns={CarouselButtons}
      >
        {data?.map(content => (
          <CarouselCard
            key={content.uuid}
            to={content.to}
            imgSrc={getThumbnail(content)}
          />
        ))}
      </CarouselBase>
    </Div>
  )
}

export default Carousel